// Subset of Rondo's @/lib/color, ported to Trading Grounds.
// Only contrastText is needed by the Button primitive; the other helpers
// (token color extraction, brand palette derivation) are landing-feature
// territory and aren't ported (PLAN.md §13.4).

/**
 * Pick white or ink text for readable contrast on an arbitrary background hex.
 * WCAG relative-luminance with a threshold tuned for the brand ink (#13102B).
 */
export function contrastText(hex: string): '#FFFFFF' | '#13102B' {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  if (!m) return '#FFFFFF'
  const toLinear = (c: number) => {
    const s = c / 255
    return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4)
  }
  const r = toLinear(parseInt(m[1] ?? '00', 16))
  const g = toLinear(parseInt(m[2] ?? '00', 16))
  const b = toLinear(parseInt(m[3] ?? '00', 16))
  const L = 0.2126 * r + 0.7152 * g + 0.0722 * b
  return L > 0.6 ? '#13102B' : '#FFFFFF'
}
